import { Button, Icon, IconIdentifier } from '@aus-platform/design-system';
import { type GenerateDTMConfirmationType } from './types';

export const GenerateDTMConfirmation: React.FC<GenerateDTMConfirmationType> = ({
  setIsGenerateDTMFormSubmitted,
}) => {
  return (
    <div className="generate-dtm__confirmation">
      <Icon identifier={IconIdentifier.Loading} size={78} />

      <div className="generate-dtm__confirmation__title">
        DTM generation request submitted.
      </div>

      <div className="generate-dtm__confirmation__description">
        Once the DTM is ready, it will be available as the captured DEM for the
        selected iteration.
      </div>

      <div className="generate-dtm__confirmation__actions">
        <Button onClick={() => setIsGenerateDTMFormSubmitted(false)}>
          Generate New Request
        </Button>
      </div>
    </div>
  );
};
